import { noStoreFetcher } from '@/utils/fetcher'
import useSWRImmutable from 'swr/immutable'
import { API_URL } from '@/utils/constants'
import { collectionObjectApiPath, normalizeCollectionObjectMeta } from '@/utils/collection-object'

export default function useCollectionMeta(slug: string) {
	const key = slug ? `${API_URL}/${collectionObjectApiPath(slug)}` : null
	return useSWRImmutable(key, async (url: string) =>
		normalizeCollectionObjectMeta(await noStoreFetcher(url), slug)
	)
}
